import { createContext } from 'react';

import { User } from '../types';

const UserContext = createContext<User>({
  email: '',
  firstName: '',
  lastName: '',
  name: '',
  roles: [],
});

export default UserContext;
